module.exports = __webpack_public_path__ + "img/thumbnail_MalayanTapir_j_albino.f758ced2.png";